export const isFinanceRoute = (url: string | null) => {
  if (!url) return false;
  return checkUrl(["/finansmagasinet"], url);
};

export const isSubscriptionRoute = (url: string | null) => {
  if (!url) return false;
  return checkUrl(["/prenumerera"], url);
};

export const isSubscriptionSiktRoute = (url: string | null) => {
  if (!url) return false;
  return checkUrl(["/prenumerera-sikt"], url);
};

export const isExchangeRoute = (url: string | null) => {
  if (!url) return false;
  return checkUrl(["/bors"], url);
};

export const isPodRoute = (url: string | null) => {
  if (!url) return false;
  return checkUrl(["/podd", "/poddar"], url);
};

export const isPlayRoute = (url: string | null) => {
  if (!url) return false;
  return checkUrl(["/play", "/program"], url);
};

export const isBookRoute = (url: string | null) => {
  if (!url) return false;
  return checkUrl(["/bok", "/sikt"], url);
};

export const isScienceRoute = (url: string | null) => {
  if (!url) return false;
  return checkUrl(["/vetenskap"], url);
};

export const isSpecialRoute = (url: string | null) => {
  return (
    isFinanceRoute(url) ||
    isPodRoute(url) ||
    isPlayRoute(url) ||
    isExchangeRoute(url) ||
    isSubscriptionRoute(url)
  );
};

export const isCurrentUnit = (
  unit: string,
  currentUnit: string | null | undefined,
) => {
  return Boolean(currentUnit && currentUnit === unit);
};

export const currentPath = (
  serverPath: string | null,
  clientPath: string | null,
) => {
  if (serverPath != clientPath) return clientPath;
  return serverPath;
};

export const prefixSlug = (
  slug: string | undefined,
  type: string | undefined,
) => {
  if (!type || !slug) return slug || "";
  const prefix = slugPrefixMap[type] || "/";
  return `${prefix}${slug}`;
};

const checkUrl = (urls: string[], path: string) =>
  urls.some((url) => path == url || path.startsWith(`${url}/`));

export const slugPrefixMap: { [key: string]: string } = {
  article: "/",
  author: "/av/",
  category: "/amne/",
  tag: "/tagg/",
  page: "/",
  play: "/play/",
  "play-show": "/program/",
  "play-episode": "/play/",
  "podcast-show": "/poddar/",
  "podcast-episode": "/podd/",
};
